import { Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../shared';

import {
    activateRoute,
    passwordRoute,
    passwordResetFinishRoute,
    passwordResetInitRoute,
    sessionsRoute,
    settingsRoute
} from './';

let ACCOUNT_ROUTES = [
    activateRoute,
    passwordRoute,
    passwordResetFinishRoute,
    passwordResetInitRoute,
    sessionsRoute,
    settingsRoute
];

export const accountState: Routes = [ {
    path: '',
    children: ACCOUNT_ROUTES
} ];



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/account.route.ts